import React from 'react';

import { ProgramTaskStatus, States } from '@vestahealthcare/common/enums';
import Enum, { Selectable } from '@vestahealthcare/common/enums/Enum';
import { translate } from '@vestahealthcare/common/i18n';

import { FilterItem, Select, SelectLanguage } from 'styleguide-v2';
import { FilterEmployeeOptions } from 'styleguide-v2/src/components/SelectAssignee';

import { GetProgramTaskParam } from 'dash/src/services/PodServices';
import { getFilterItem } from 'dash/src/utils/filterUtils';

const ATTEMPTS_OPTIONS = [
  { label: translate('global.none'), value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5+', value: 5 },
];

type KeyGetProgramTaskParams = keyof GetProgramTaskParam;

type Props = {
  data: {
    employees: Selectable[];
    languages: Selectable[];
  };
  filters?: {
    [x in KeyGetProgramTaskParams]?: FilterItem;
  };
  loading?: boolean;
  onChange: (
    filters: {
      [x in KeyGetProgramTaskParams]?: FilterItem;
    },
  ) => void;
};

export const ForecastDetailTaskFilterBar = ({
  data,
  filters,
  loading,
  onChange,
}: Props) => (
  <>
    <Select
      data-cy="pod-metrics-task-detail-filter-bar-state"
      items={Enum.toSelectable(States.asArray)}
      limitTags={1}
      multiple
      onChange={(values: Selectable[]) =>
        onChange({
          ...filters,
          state: getFilterItem(
            translate('pods.metrics.forecastDetail.filter.state'),
            values,
          ),
        })
      }
      placeholder={translate('pods.metrics.forecastDetail.filter.state')}
      placeholderV2
      size="xs"
      value={filters?.state?.value || []}
    />
    <SelectLanguage
      data-cy="pod-metrics-task-detail-filter-bar-language"
      items={data.languages}
      limitTags={1}
      loading={loading}
      onChange={(values: Selectable[]) =>
        onChange({
          ...filters,
          language: getFilterItem(
            translate('pods.metrics.forecastDetail.filter.language'),
            values,
          ),
        })
      }
      placeholder={translate('pods.metrics.forecastDetail.filter.language')}
      placeholderV2
      size="xs"
      value={(filters?.language?.value as Selectable[]) || []}
    />
    <Select
      data-cy="pod-metrics-task-detail-filter-bar-assignee"
      filterOptions={FilterEmployeeOptions}
      items={data.employees}
      limitTags={1}
      loading={loading}
      multiple
      onChange={(values: Selectable[]) =>
        onChange({
          ...filters,
          assigneeId: getFilterItem(
            translate('pods.metrics.forecastDetail.filter.taskAssignee'),
            values,
          ),
        })
      }
      placeholder={translate('pods.metrics.forecastDetail.filter.taskAssignee')}
      placeholderV2
      size="xs"
      value={filters?.assigneeId?.value || []}
    />
    <Select
      data-cy="pod-metrics-task-detail-filter-bar-status"
      items={Enum.toSelectable(ProgramTaskStatus.asArray)}
      multiple
      onChange={(value?: Selectable) =>
        onChange({
          ...filters,
          statusId: getFilterItem(
            translate('pods.metrics.forecastDetail.filter.status'),
            value,
          ),
        })
      }
      placeholder={translate('pods.metrics.forecastDetail.filter.status')}
      placeholderV2
      size="xs"
      value={filters?.statusId?.value || []}
    />
    <Select
      data-cy="pod-metrics-task-detail-filter-bar-attempts"
      items={ATTEMPTS_OPTIONS}
      multiple
      onChange={(value?: Selectable) =>
        onChange({
          ...filters,
          attempt: getFilterItem(
            translate('pods.metrics.forecastDetail.filter.attempts'),
            value,
          ),
        })
      }
      placeholder={translate('pods.metrics.forecastDetail.filter.attempts')}
      placeholderV2
      size="xs"
      value={filters?.attempt?.value || []}
    />
  </>
);
